import { render, staticRenderFns } from "./PiDialog.vue?vue&type=template&id=35414f6a"
import script from "./PiDialog.vue?vue&type=script&lang=js"
export * from "./PiDialog.vue?vue&type=script&lang=js"
import style0 from "./PiDialog.vue?vue&type=style&index=0&id=35414f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports